// Núcleo da UI: navegação, sidebar, header, títulos de rota, saudações e o
// dashboard. Chaves compartilhadas por várias telas. Ver src/i18n/index.jsx.
const core = {
  pt: {
    'nav.home': 'Início', 'nav.pix': 'PIX', 'nav.extrato': 'Extrato',
    'nav.investimentos': 'Investimentos', 'nav.perfil': 'Perfil', 'nav.evildog': 'EvilDog',
    'sidebar.help_title': 'Precisa de ajuda?',
    'sidebar.help_text': 'Nossa equipe está sempre disponível.',
    'sidebar.talk_support': 'Falar com suporte',
    'header.premium': 'Conta Premium', 'header.my_profile': 'Meu perfil', 'header.logout': 'Sair',
    'header.user': 'Usuário',
    'title.dashboard': 'Painel Geral', 'title.pix': 'PIX', 'title.pix_confirm': 'PIX • Confirmar',
    'title.pix_receipt': 'PIX • Comprovante', 'title.extrato': 'Extrato',
    'title.investimentos': 'Investimentos', 'title.cartoes': 'Cartões', 'title.perfil': 'Perfil',
    'title.evildog': 'EvilDog • Attack Console', 'title.default': 'Painel',
    'greeting.morning': 'Bom dia', 'greeting.afternoon': 'Boa tarde', 'greeting.evening': 'Boa noite',
    'dash.welcome': 'Bem-vindo ao seu painel do DogBank',
    'dash.available_balance': 'Saldo disponível', 'dash.account': 'Conta {n}',
    'dash.make_pix': 'Fazer PIX', 'dash.view_statement': 'Ver extrato',
    'dash.invest': 'Invest', 'dash.demo_wallet': 'Carteira demo', 'dash.cdi_btc': 'CDI 100% e Bitcoin',
    'dash.wallet_desc': 'Carteira com renda fixa e ativos digitais.',
    'dash.latest_tx': 'Últimas transações', 'dash.view_all': 'Ver todas',
    'dash.no_tx': 'Nenhuma transação encontrada ainda.',
    'dash.invest_wallet': 'Carteira de investimentos', 'dash.active_products': 'Produtos ativos',
    'dash.summary': 'Resumo', 'dash.contributions': 'Aportes e rendimento diário',
    'dash.view_investments': 'Ver investimentos', 'dash.loading': 'Carregando seus dados...',
    'dash.load_error': 'Não foi possível carregar os dados. Tente novamente mais tarde.',
    'tx.received': 'Recebimento', 'tx.transfer': 'Transferência',
    'common.client': 'Cliente',
  },
  es: {
    'nav.home': 'Inicio', 'nav.pix': 'PIX', 'nav.extrato': 'Movimientos',
    'nav.investimentos': 'Inversiones', 'nav.perfil': 'Perfil', 'nav.evildog': 'EvilDog',
    'sidebar.help_title': '¿Necesitas ayuda?',
    'sidebar.help_text': 'Nuestro equipo siempre está disponible.',
    'sidebar.talk_support': 'Hablar con soporte',
    'header.premium': 'Cuenta Premium', 'header.my_profile': 'Mi perfil', 'header.logout': 'Salir',
    'header.user': 'Usuario',
    'title.dashboard': 'Panel General', 'title.pix': 'PIX', 'title.pix_confirm': 'PIX • Confirmar',
    'title.pix_receipt': 'PIX • Comprobante', 'title.extrato': 'Movimientos',
    'title.investimentos': 'Inversiones', 'title.cartoes': 'Tarjetas', 'title.perfil': 'Perfil',
    'title.evildog': 'EvilDog • Attack Console', 'title.default': 'Panel',
    'greeting.morning': 'Buenos días', 'greeting.afternoon': 'Buenas tardes', 'greeting.evening': 'Buenas noches',
    'dash.welcome': 'Bienvenido a tu panel de DogBank',
    'dash.available_balance': 'Saldo disponible', 'dash.account': 'Cuenta {n}',
    'dash.make_pix': 'Hacer PIX', 'dash.view_statement': 'Ver movimientos',
    'dash.invest': 'Invertir', 'dash.demo_wallet': 'Cartera demo', 'dash.cdi_btc': 'CDI 100% y Bitcoin',
    'dash.wallet_desc': 'Cartera con renta fija y activos digitales.',
    'dash.latest_tx': 'Últimas transacciones', 'dash.view_all': 'Ver todas',
    'dash.no_tx': 'Aún no hay transacciones.',
    'dash.invest_wallet': 'Cartera de inversiones', 'dash.active_products': 'Productos activos',
    'dash.summary': 'Resumen', 'dash.contributions': 'Aportes y rendimiento diario',
    'dash.view_investments': 'Ver inversiones', 'dash.loading': 'Cargando tus datos...',
    'dash.load_error': 'No se pudieron cargar los datos. Inténtalo de nuevo más tarde.',
    'tx.received': 'Ingreso', 'tx.transfer': 'Transferencia',
    'common.client': 'Cliente',
  },
  en: {
    'nav.home': 'Home', 'nav.pix': 'PIX', 'nav.extrato': 'Statement',
    'nav.investimentos': 'Investments', 'nav.perfil': 'Profile', 'nav.evildog': 'EvilDog',
    'sidebar.help_title': 'Need help?',
    'sidebar.help_text': 'Our team is always available.',
    'sidebar.talk_support': 'Contact support',
    'header.premium': 'Premium Account', 'header.my_profile': 'My profile', 'header.logout': 'Log out',
    'header.user': 'User',
    'title.dashboard': 'Overview', 'title.pix': 'PIX', 'title.pix_confirm': 'PIX • Confirm',
    'title.pix_receipt': 'PIX • Receipt', 'title.extrato': 'Statement',
    'title.investimentos': 'Investments', 'title.cartoes': 'Cards', 'title.perfil': 'Profile',
    'title.evildog': 'EvilDog • Attack Console', 'title.default': 'Dashboard',
    'greeting.morning': 'Good morning', 'greeting.afternoon': 'Good afternoon', 'greeting.evening': 'Good evening',
    'dash.welcome': 'Welcome to your DogBank dashboard',
    'dash.available_balance': 'Available balance', 'dash.account': 'Account {n}',
    'dash.make_pix': 'Send PIX', 'dash.view_statement': 'View statement',
    'dash.invest': 'Invest', 'dash.demo_wallet': 'Demo wallet', 'dash.cdi_btc': '100% CDI & Bitcoin',
    'dash.wallet_desc': 'Fixed income and digital assets portfolio.',
    'dash.latest_tx': 'Latest transactions', 'dash.view_all': 'View all',
    'dash.no_tx': 'No transactions yet.',
    'dash.invest_wallet': 'Investment portfolio', 'dash.active_products': 'Active products',
    'dash.summary': 'Summary', 'dash.contributions': 'Contributions & daily yield',
    'dash.view_investments': 'View investments', 'dash.loading': 'Loading your data...',
    'dash.load_error': 'Could not load your data. Please try again later.',
    'tx.received': 'Incoming', 'tx.transfer': 'Transfer',
    'common.client': 'Customer',
  },
  it: {
    'nav.home': 'Home', 'nav.pix': 'PIX', 'nav.extrato': 'Movimenti',
    'nav.investimentos': 'Investimenti', 'nav.perfil': 'Profilo', 'nav.evildog': 'EvilDog',
    'sidebar.help_title': 'Serve aiuto?',
    'sidebar.help_text': 'Il nostro team è sempre disponibile.',
    'sidebar.talk_support': 'Contatta il supporto',
    'header.premium': 'Conto Premium', 'header.my_profile': 'Il mio profilo', 'header.logout': 'Esci',
    'header.user': 'Utente',
    'title.dashboard': 'Panoramica', 'title.pix': 'PIX', 'title.pix_confirm': 'PIX • Conferma',
    'title.pix_receipt': 'PIX • Ricevuta', 'title.extrato': 'Movimenti',
    'title.investimentos': 'Investimenti', 'title.cartoes': 'Carte', 'title.perfil': 'Profilo',
    'title.evildog': 'EvilDog • Attack Console', 'title.default': 'Pannello',
    'greeting.morning': 'Buongiorno', 'greeting.afternoon': 'Buon pomeriggio', 'greeting.evening': 'Buonasera',
    'dash.welcome': 'Benvenuto nella tua dashboard DogBank',
    'dash.available_balance': 'Saldo disponibile', 'dash.account': 'Conto {n}',
    'dash.make_pix': 'Invia PIX', 'dash.view_statement': 'Vedi movimenti',
    'dash.invest': 'Investi', 'dash.demo_wallet': 'Portafoglio demo', 'dash.cdi_btc': 'CDI 100% e Bitcoin',
    'dash.wallet_desc': 'Portafoglio con reddito fisso e asset digitali.',
    'dash.latest_tx': 'Ultime transazioni', 'dash.view_all': 'Vedi tutte',
    'dash.no_tx': 'Ancora nessuna transazione.',
    'dash.invest_wallet': 'Portafoglio investimenti', 'dash.active_products': 'Prodotti attivi',
    'dash.summary': 'Riepilogo', 'dash.contributions': 'Versamenti e rendimento giornaliero',
    'dash.view_investments': 'Vedi investimenti', 'dash.loading': 'Caricamento dei tuoi dati...',
    'dash.load_error': 'Impossibile caricare i dati. Riprova più tardi.',
    'tx.received': 'Accredito', 'tx.transfer': 'Bonifico',
    'common.client': 'Cliente',
  },
};

export default core;
